import apiClient from "@/util/apiClient";

export async function isWithinOperationHours(): Promise<boolean> {
  try {
    const response = await apiClient.post("/api/System/checkOperationTime", {});

    return response.data.isWithinOperationHours;
  } catch (error) {
    console.error("Error checking operation hours:", error);
    throw error;
  }
}
